function getLoadingWindowContent(loadingMessage: string): string {
  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${loadingMessage}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html, body {
          height: 100%;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        body {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
        }

        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          max-width: 300px;
          padding: 20px;
        }

        .spinner {
          animation: rotator 1s linear infinite;
          margin-bottom: 24px;
        }

        @keyframes rotator {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .message {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          color: hsl(var(--foreground, 222.2 84% 4.9%));
        }
      </style>
    </head>
    <body>
      <div class="container">
        <svg
          class="spinner"
          xmlns="http://www.w3.org/2000/svg"
          width="47"
          height="47"
          viewBox="0 0 47 47"
          fill="none"
          aria-label="${loadingMessage}"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.6 5.28009C21.6 4.4848 22.2447 3.84009 23.04 3.84009C26.8374 3.84009 30.5495 4.96615 33.7069 7.07587C36.8644 9.1856 39.3253 12.1842 40.7785 15.6926C42.2317 19.2009 42.6119 23.0614 41.8711 26.7858C41.1302 30.5103 39.3016 33.9314 36.6164 36.6165C33.9313 39.3017 30.5102 41.1303 26.7857 41.8712C23.0613 42.612 19.2008 42.2318 15.6925 40.7786C12.1841 39.3254 9.1855 36.8645 7.07578 33.707C4.96606 30.5496 3.84 26.8375 3.84 23.0401C3.84 22.2448 4.48471 21.6001 5.28 21.6001C6.07529 21.6001 6.72 22.2448 6.72 23.0401C6.72 26.2679 7.67715 29.4232 9.47041 32.107C11.2637 34.7908 13.8125 36.8826 16.7946 38.1178C19.7767 39.353 23.0581 39.6762 26.2239 39.0465C29.3896 38.4168 32.2976 36.8625 34.58 34.5801C36.8624 32.2977 38.4167 29.3897 39.0464 26.224C39.6761 23.0582 39.3529 19.7768 38.1177 16.7947C36.8825 13.8126 34.7907 11.2638 32.1069 9.4705C29.4231 7.67724 26.2678 6.72009 23.04 6.72009C22.2447 6.72009 21.6 6.07538 21.6 5.28009Z"
            fill="#29A34A"
          />
        </svg>
        <p class="message">${loadingMessage}...</p>
      </div>
    </body>
    </html>
  `;
}

export { getLoadingWindowContent };
